export const SPECIAL_FILTER_VALUES = { ALL: 'all' };

export const SELECT_ALL_VALUE = {
  label: 'All',
  value: SPECIAL_FILTER_VALUES.ALL,
};

export const CSV_SPLIT_SEPARATOR = ',';
